
<tilby-dialog-toolbar
    mat-dialog-title
    title="CASHREGISTER.SATISPAY_PAYMENTS.TITLE"
    [hideConfirm]="true"
>
    <div class="tw-flex tw-justify-end tw-w-full tw-mr-4 tw-font-bold" toolbar-content>
        @if(amountToPay){
            <span>{{amountToPay | tilbyCurrency}}</span>
        }
    </div>
</tilby-dialog-toolbar>
@if(operationInProgress) {
    <tilby-dialog-progress-bar />
}
@if(isOffline){
    <div class="tw-flex tw-justify-center tw-items-center tw-bg-red-500 tw-min-h-12">
        <span class="tw-text-white">{{'CASHREGISTER.SATISPAY_PAYMENTS.CHECK_CONNECTION' | translate}}</span>
    </div>
}
@if(message){
    <div class="tw-flex tw-justify-center tw-items-center tw-bg-red-500 tw-min-h-12" (click)="deleteMessage()">
        <span class="tw-text-white">{{message}}</span>
    </div>
}
<tilby-dialog-content>
    @if(setupForm) {
        <div class="tw-flex tw-justify-center tw-items-center tw-mb-4">
            <span class="tw-whitespace-pre-line tw-text-center">{{'CASHREGISTER.SATISPAY_PAYMENTS.PAIR_NECESSARY' | translate}}</span>
        </div>
        <form [formGroup]="setupForm" (ngSubmit)="pairShop()" class="tw-flex tw-flex-col">
            <mat-form-field appearance="fill" class="tw-pb-4">
                <mat-label>{{'CASHREGISTER.SATISPAY_PAYMENTS.PAIR_CODE' | translate}}</mat-label>
                <input matInput formControlName="activationCode" type="text" id="SatispayCodeInput" required/>
            </mat-form-field>
            <button mat-raised-button color="primary" type="submit" [disabled]="!setupForm.valid">{{'CASHREGISTER.SATISPAY_PAYMENTS.PAIR' | translate}}</button>
        </form>
    } @else if(kioskMode) {
        @if(matchCodePayment?.code_identifier) {
            <div class="tw-flex tw-justify-center tw-items-center tw-mb-4">
                <span class="tw-whitespace-pre-line tw-text-center">{{'CASHREGISTER.SATISPAY_PAYMENTS.SCAN_QRCODE' | translate}}</span>
            </div>
            <qrcode
                class="tw-text-center"
                [qrdata]="matchCodePayment!.code_identifier!"
                [width]="300"
                [imageSrc]="'assets/images/misc/satispay.png'"
                [imageHeight]="64"
                [imageWidth]="64"
                [errorCorrectionLevel]="'medium'">
            </qrcode>
        } @else {
            <div class="satispay-loader" id="load-wrapper">
                <div id="loader">
                    <span class="ringFour"></span>
                    <span class="ringThree"></span>
                    <span class="colorRing"></span>
                    <span class="ringTwo"></span>
                    <span class="ball"></span>
                </div>
            </div>
        }
    } @else if(!this.payments.length) {
        <div class="satispay-loader" id="load-wrapper">
            <div id="loader">
                <span class="ringFour"></span>
                <span class="ringThree"></span>
                <span class="colorRing"></span>
                <span class="ringTwo"></span>
                <span class="ball"></span>
            </div>
            <div id="label">
                <p>{{'CASHREGISTER.SATISPAY_PAYMENTS.WAITING_PAYMENTS' | translate}}</p>
            </div>
        </div>
    } @else {
        <mat-list>
            @for(payment of payments; track payment.id){    
                <mat-list-item>
                    <div class="tw-mx-4" matListItemAvatar [ngClass]="{ 'tw-opacity-25': payment.disabled }" (click)="selectPayment(payment)">
                        @if(payment.customer_image) {   
                            <img class="tw-size-10 tw-rounded-full" src="{{payment.customer_image}}"/>
                        } @else if(payment.original_data.code_identifier) {
                            <mat-icon class="tw-size-10 tw-text-[40px] material-symbols-outlined">qr_code_2</mat-icon>
                        } @else {
                            <mat-icon class="tw-size-10 tw-text-[40px]">account_circle</mat-icon>
                        }
                    </div>
                    <div matListItemTitle [ngClass]="{ 'tw-opacity-25': payment.disabled }" (click)="selectPayment(payment)">{{payment.customer_name}}</div>
                    <div matListItemLine class="tw-font-bold" [ngClass]="{ 'tw-opacity-25': payment.disabled }" (click)="selectPayment(payment)">{{payment.customer_amount | tilbyCurrency}}</div>
                    <div class="tw-m-auto" matListItemMeta>
                        @if(!payment.removed){
                            <button mat-icon-button (click)="removePayment(payment)">
                                <mat-icon alt="Delete payment">close</mat-icon>
                            </button>
                        }
                    </div>
                </mat-list-item>
            }
        </mat-list>
    }
</tilby-dialog-content>